import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { addDefaultSrc, getDefaultSrc, useSetVisitedToTrue } from '../news-helpers';
import { GetNewsMoreInformationLinks } from '../../../../utils/news-util';
import pathConst, { QUERY_PID, QUERY_INVESTOR } from '../../../../constants/PathsConstant';
import LinkShare from '../../../../components/GeneralForm/LinkShare';
import Page from '../../../../components/Page';
import { useGetNewsDetailsQuery, useGetLatestNewsQuery } from './../news-api';
import MostRead from './MostRead';
import { dateToNull } from '../../../../utils/general-util';
import SafeHtml from '../../../../components/SafeHtml';

export default function ArticleFull({ newsId, newsIds, getNextPage, isLoading, hasMore, backLink }) {
  const userId = useSelector((state) => state.user.userId);
  const latestNews = useGetLatestNewsQuery();

  const newsDetails = useGetNewsDetailsQuery({
    newsid: newsId,
  });

  if (newsDetails.status !== 'fulfilled') {
    return <div>Loading...</div>;
  }

  return (
    <Page>
      <div className="cr-newsNew row">
        <Article
          newsDetails={newsDetails.data}
          latestNews={latestNews}
          newsIds={newsIds}
          userId={userId}
          getNextPage={getNextPage}
          isLoading={isLoading}
          hasMore={hasMore}
          backLink={backLink}
        />
      </div>
    </Page>
  );
}

function Article({ newsDetails, latestNews, newsIds, userId, getNextPage, isLoading, hasMore, backLink }) {
  const history = useHistory();
  const location = useLocation();
  const [lstNewsCompanyLinks, setLstNewsCompanyLinks] = useState([]);
  const [error, setError] = useState(false);
  const lstNewsTimelineTop5 = [];
  const isValidUser = true;

  useSetVisitedToTrue(newsDetails.visited, newsDetails.newsid, userId);

  useEffect(() => {
    GetNewsMoreInformationLinks(newsDetails.newsid)
      .then((res) => {
        setLstNewsCompanyLinks(res);
      })
      .catch((error) => setError(true));
  }, []);

  const [prevNewsId, nextNewsId] = useMemo(() => {
    const currentNewsIndex = newsIds.findIndex((id) => id === newsDetails.newsid);
    if (currentNewsIndex === newsIds.length - 1 && !isLoading && hasMore) {
      getNextPage();
    }

    return [newsIds[currentNewsIndex - 1], newsIds[currentNewsIndex + 1]];
  }, [newsDetails, newsIds]);

  const handlePreviousNewsClick = () => {
    history.push(location.search.replace(newsDetails.newsid, prevNewsId));
  };

  const handleNextNewsClick = () => {
    history.push(location.search.replace(newsDetails.newsid, nextNewsId));
  };

  return (
    <>
      <div className="col-xs-12 col-sm-12 col-lg-9 col-xl-9 p-0 position-reliatve">
        <div className="newsblock ">
          <div id="newsMain" className="row newsMain fadeInAnimation">
            {history.location.pathname !== pathConst.MY_ALERT_INBOX ? (
              <div className="row">
                <div className="col-3">
                  <button
                    type="button"
                    onClick={() => history.push(backLink || location.pathname)}
                    className="article-button mb-3 d-none d-md-block d-sm-block d-xs-block mr-auto btn btn-primary btn-sm"
                  >
                    Back
                  </button>
                </div>
              </div>
            ) : (
              ''
            )}
            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 order-xs-1 order-sm-1 order-md-2 order-lg-2 order-xl-2">
              <img
                onError={addDefaultSrc}
                src={getDefaultSrc(newsDetails)}
                className="rounded w-100 h-auto mx-auto d-block"
                alt="newslogo"
              />
            </div>
            <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 order-xs-2 order-sm-2 order-md-1 order-lg-1 order-xl-1">
              <div className="">
                <div className="row bottomSaprator" />
                <div className="row col-xs-12 col-sm-12 col-md-12 col-lg-12 py-auto newsExpandHeadline">
                  <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 mr-auto py-auto">
                    <div>
                      <p>
                        <SafeHtml html={newsDetails?.headLine} tag="b" className="newsHeaderArticle textBreakLine" />
                      </p>
                    </div>
                  </div>
                  <div className="row newsDate py-auto my-auto">
                    <div className="col-8 py-auto my-auto">{newsDetails?.newsDate}</div>
                    {history.location.pathname !== pathConst.MY_ALERT_INBOX ? (
                      <div className="col-4 justify-content-end py-auto">
                        <LinkShare
                          newsid={newsDetails?.newsid}
                          mailSubject={newsDetails?.headLine}
                          mailBody={newsDetails?.shortArticle}
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
              <div className="bottomSaprator" />
              <div className="row py-auto">
                <div className="col-6 fontBlack">
                  {newsDetails?.categories !== undefined && newsDetails?.categories !== null ? (
                    <div>
                      <b className="col-4 bolder me-3">Categories:</b>
                      <span className="col-8 font-italic fontBlack">{newsDetails?.categories}</span>
                    </div>
                  ) : (
                    <div />
                  )}
                </div>
                {history.location.pathname !== pathConst.MY_ALERT_INBOX && newsIds.length > 0 ? (
                  <div className="col-xs-12 col-sm-12 col-md-6 d-flex justify-content-xs-start justify-content-sm-start justify-content-md-end mb-1">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm text-white article-button float-end me-3"
                      onClick={handlePreviousNewsClick}
                      disabled={!prevNewsId}
                    >
                      <span className="bi bi-chevron-left ml-auto text-white" />
                      Previous Story
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary btn-sm text-white article-button float-end"
                      onClick={handleNextNewsClick}
                      disabled={!nextNewsId}
                    >
                      Next Story
                      <span className="bi bi-chevron-right mr-auto text-white" />
                    </button>
                  </div>
                ) : (
                  ''
                )}
              </div>
              <div className="bottomSaprator" />
              <div className="row mt-4">
                <div className="col-12">
                  <i className={newsDetails?.readOnly ? 'readOnly' : ''} />
                  <SafeHtml html={newsDetails?.article} tag="p" className="pt-1 textBreakLine" />
                </div>
              </div>
              {!error && (
                <div className="row">
                  {lstNewsCompanyLinks?.length > 0 && (
                    <div className=" mt-4 col-12 cardInformation">
                      <div className="row">
                        {/* <div className='col-md-12 bs-linebreak' /> */}
                        <hr />
                      </div>
                      <div className="cardInformationHeader">More Information On</div>
                      <ul className="list-group list-group-flush">
                        {lstNewsCompanyLinks.map((element, index) => (
                          <p key={`key${index + 1}`} className="py-1 row">
                            <a
                              href={
                                element.link_type === 'company'
                                  ? `${pathConst.COMPANY_OVERVIEW}${QUERY_PID}${element.id}`
                                  : `${pathConst.INVESTOR_OVERVIEW}${QUERY_INVESTOR}${element.id}`
                              }
                              className="text-decoration-none fontBlack col-sm-12 col-md-4"
                              tabIndex="-1"
                              aria-disabled="false"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {element.name}
                            </a>
                            <a
                              href={
                                element.link_type === 'company'
                                  ? `${pathConst.NEWS}${QUERY_PID}${element.id}`
                                  : `${pathConst.INVESTOR_NEWS}${QUERY_INVESTOR}${element.id}`
                              }
                              className="moreNewsLinks col-sm-12 col-md-4"
                              tabIndex="-1"
                              role="button"
                              aria-disabled="false"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              More News
                            </a>
                          </p>
                        ))}
                      </ul>
                    </div>
                  )}
                  <div className="row">
                    {lstNewsTimelineTop5?.length > 0 && (
                      <div className=" mt-2 col-12 cardInformation">
                        <div className="row">
                          <div className="col-md-12 bs-linebreak" />
                        </div>
                        <div className="cardInformationHeader">
                          Activism Timelines
                          {isValidUser === false && (
                            <span className="text-danger text-capitalize">
                              {' '}
                              (Only available to subscribers of Activism and Activism Shorts modules)
                            </span>
                          )}
                        </div>
                        <ul className="list-group list-group-flush">
                          {lstNewsTimelineTop5.map((element, index) => (
                            <p
                              key={`key${index + 1}`}
                              className={isValidUser ? 'py-1 fontBlack' : 'py-1 fontBlack blurrytext'}
                            >
                              <p className="cardInformationDate">
                                {dateToNull(element?.summary_date, 'dd mmm yyyy', true)}
                              </p>
                              {element.Timeline}
                            </p>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12 col-sm-12 col-lg-3 col-xl-3">
        {latestNews.data && latestNews.data.length > 0 && (
          <div className="mostComponentOverall">
            <div className="mostReadTitle">Latest News</div>
            <div className="mostVisitNewsContainer">
              {latestNews.data.map((newsItem) => (
                <MostRead key={newsItem.newsid} newsDetails={newsItem} />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
}
